// extracted by mini-css-extract-plugin
export default {"container":"SocialLink_container__TpbaX","tel":"SocialLink_tel__426ex","link":"SocialLink_link__y4WyN"};